import { Flex} from "@chakra-ui/react";
import LaunchdeckSpinner from './LaunchdeckSpinner';


const PageLoader = ({boxSize ="7em"}) => {
	return (
		<Flex w='100%' alignItems='center' justify='center' height='30vh' >
			<LaunchdeckSpinner boxSize={boxSize} thickness='5px' />
		</Flex>
	);
};

export default PageLoader;
